<section id="solution-portfolio" class="solution-portfolio-section">
  <h2>{{ 'SOLUTION_PORTFOLIO.TITLE' | translate }}</h2>

  <div class="portfolio-card">
    <h3>{{ 'SOLUTION_PORTFOLIO.SOLUTIONS_SUBTITLE' | translate }}</h3>

    @if (solutions.length === 0) {
      <p class="no-solutions">{{ 'SOLUTION_PORTFOLIO.NO_SOLUTIONS' | translate }}</p>
    } @else {
      <div class="solutions-grid">
        @for (solution of solutions; track solution.id) {
          <button
            class="solution-tile"
            [class.active]="isSolutionSelected(solution.id)"
            (click)="toggleSolution(solution.id)">
            <!-- blue border overlay -->
            <div class="tile-border"></div>
            <!-- top row: blue banner + category label -->
            <div class="tile-header">
              <div class="banner-group">
                <div class="blue-banner">
                  <div class="icon-wrap">
                    <img [src]="solution.logoIconUrl" [alt]="solution.name" width="32" height="32">
                  </div>
                  <div class="name-wrap">
                    <img [src]="solution.logoNameUrl" [alt]="solution.name" class="name-img">
                  </div>
                </div>
                <div class="banner-tail">
                  <svg viewBox="0 0 16 48" fill="none" width="16" height="48">
                    <path d="M0 0L16 48H0V0Z" fill="#0066CC"/>
                  </svg>
                </div>
              </div>
              <div class="category-wrap">
                <img [src]="solution.logoCategoryUrl" [alt]="solution.name" class="category-img">
              </div>
            </div>
            <!-- description -->
            <div class="tile-desc">
              <p>{{ solution.description }}</p>
            </div>
          </button>
        }
      </div>
    }
  </div>
</section>
